import { doGet } from '../fetch';

export const getWellnessData = async (patient_id) => {
  const card = await doGet(`/b2c/patient-wellness-data`);
  return card;
};
